<template>
  <nav v-if="partner.logo" class="flex justify-center ph2">
    <img
      :src="require(`@/assets/images/partner-logo/${partner.logo}`)"
      alt="Partner Logo"
      loading="lazy"
      style="max-width: 100px; margin: 20px 0"
    />
  </nav>
</template>

<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
};
</script>
